// extracted by css-extract-rspack-plugin
export default {"panel":"GeneralTabPanel_panel__doibO","mobile":"GeneralTabPanel_mobile__65zAc","divider":"GeneralTabPanel_divider__89jlO"};